import React from "react";
import styled from "styled-components";

export const ScatterPlotWrapper = styled.div`
  &.landscape {
    display: flex;
    // margin-top: -20px;
    padding-left: 50px;
    padding-right: 20px;
  }
`;
  
export const FloatingSlider = styled.div`
  position: absolute !important;
  left: 611px;
`;

export const TopFloatingSlider = styled((props) => <FloatingSlider {...props}/>)`
  top: 430px;
`;

export const BottomFloatingSlider = styled((props) => <FloatingSlider {...props}/>)`
  top: 836px;
`;

export const SliderBackground = styled.div`
  width: ${props => {
    let width = props.marks.length * 25;
    width = Math.max(width, 50);
    width = Math.min(width, 125);
    return width;
  }}px !important;
  background: #e6e6e6;
  border-radius: 3px;
  padding: 0 14px;
  display: flex;
`;

export const SliderLabel = styled.div`
  font-size: 13px;
  color: #7d7d7d;
  margin-top: 4px;
`;


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/ScatterPlots/style.js